import React from 'react';
import { Typography, List, ListItem, ListItemIcon, ListItemText, Divider, Box, useTheme } from '@mui/material';
import { Calendar } from 'lucide-react';
import dayjs from 'dayjs';
import { CalendarEvent } from './CalendarEvent';
import { CalendarEventType } from './types';

interface UpcomingEventsProps {
  events: {
    date: string;
    items: CalendarEventType[];
  }[];
  isMobile?: boolean;
}

export const UpcomingEvents: React.FC<UpcomingEventsProps> = ({ 
  events,
  isMobile,
}) => {
  const theme = useTheme();

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Upcoming Events
      </Typography>
      <List>
        {events.map((dateEvents, index) => (
          <React.Fragment key={dateEvents.date}>
            <ListItem sx={{ px: 0 }}>
              <ListItemIcon sx={{ minWidth: 40 }}>
                <Calendar size={20} />
              </ListItemIcon>
              <ListItemText
                primary={dayjs(dateEvents.date).format('MMM D, YYYY')}
                secondary={
                  <Box sx={{ mt: 1 }}>
                    {dateEvents.items.map((event, eventIndex) => (
                      <Box key={eventIndex} sx={{ mb: 0.5 }}>
                        <CalendarEvent 
                          event={event}
                          isMobile={isMobile}
                        />
                      </Box>
                    ))}
                  </Box>
                }
                primaryTypographyProps={{
                  variant: 'subtitle2',
                  color: 'text.primary',
                }}
              />
            </ListItem>
            {index < events.length - 1 && <Divider />}
          </React.Fragment>
        ))}
        {events.length === 0 && (
          <ListItem>
            <ListItemText
              primary="No upcoming events"
              primaryTypographyProps={{
                color: 'text.secondary',
                align: 'center',
              }}
            />
          </ListItem>
        )}
      </List>
    </Box>
  );
};